/**
 * Axis of the arrangement of virtual list elements.
 * @link https://github.com/DjonnyX/rcx-virtual-list/tree/main/src/lib/src/enums/directions.ts
 * @author Evgenii Grebennikov
 * @email djonnyx@gmail.com
 */
export var Directions;
(function (Directions) {
    /**
     * Horizontal axis.
     */
    Directions["HORIZONTAL"] = "horizontal";
    /**
     * Vertical axis.
     */
    Directions["VERTICAL"] = "vertical";
})(Directions || (Directions = {}));
